import { gql } from '@apollo/client';

export default gql`
  query templates($page: Int, $name: String, $sortBy: String) {
    space {
      adminRole
    }
    templates(page: $page, name: $name, sortBy: $sortBy) {
      templatesTotalPages
      templatesTotal
      perPage
      hasNextPage
      templates {
        id
        name
      }
    }
  }
`;
